import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

import { ref, getCurrentInstance, withDefaults, onMounted, watch } from 'vue';

	interface main {
		id ?: string | number,
		size ?: string,
		ValueKey ?: string,
		LabelKey ?: string,
		width ?: string | number,
		disabled ?: boolean,
		IsAuto ?: boolean,
	}
export default /*#__PURE__*/_defineComponent({
  __name: 'UnitSelect',
  props: {
    id: { default: "" },
    size: { default: "default" },
    ValueKey: { default: "label" },
    LabelKey: { default: "label" },
    width: { default: "100%" },
    disabled: { type: Boolean, default: false },
    IsAuto: { type: Boolean, default: false }
  },
  emits: ["update:id", "change", "clear"],
  setup(__props: any, { emit: __emit }) {

	;

	const props = __props;

	const { proxy } = getCurrentInstance() as any;
	const emits = __emit;
	const UnitId = ref<any>("");
	const UnitList = ref<any>([]);
	const loading = ref(false);
	const placeholder = ref("请选择单位");

	watch(() => props.id, (n : any) => {
		UnitId.value = n;
	});

	onMounted(() => {
		UnitId.value = props.id;
		if (props.IsAuto) {
			if (proxy.$store.state.IsRefreshUnit) {
				GetData();
			} else {
				if (proxy.$store.state.UnitList.length > 0) {
					UnitList.value = proxy.$store.state.UnitList;
				} else {
					GetData();
				}
			}
		}
	});

	const UnitChange = (data : any) => {
		console.log(data)
		emits("update:id", data);
		emits("change", data);
	};
	const UnitClear = () => {
		emits("clear");
	};
	const SelectFocus = () => {
		if (proxy.$store.state.IsRefreshUnit) {
			GetData();
		} else {
			if (proxy.$store.state.UnitList.length > 0) {
				UnitList.value = proxy.$store.state.UnitList;
			} else {
				GetData();
			}
		}
	};
	const GetData = () => {
		proxy.$api.tokenRequest({
			url: '/admin/type',
			data: {
				type: 3,
				is_page: 0
			},
			success: (res : any) => {
				UnitList.value = res.data;
				proxy.$store.commit("GetAllList", {
					type: 19,
					data: res.data,
				});
			},
		});
	}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createBlock(_component_el_select, {
    "remote-show-suffix": "",
    clearable: "",
    filterable: "",
    style: _normalizeStyle({'width': `${_ctx.width}`}),
    disabled: _ctx.disabled,
    size: _ctx.size,
    modelValue: UnitId.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((UnitId).value = $event)),
    loading: loading.value,
    onFocus: SelectFocus,
    placeholder: placeholder.value,
    onChange: UnitChange,
    onClear: UnitClear
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(UnitList.value, (v) => {
        return (_openBlock(), _createBlock(_component_el_option, {
          key: v.value,
          label: v[_ctx.LabelKey],
          value: v[_ctx.ValueKey]
        }, null, 8, ["label", "value"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["style", "disabled", "size", "modelValue", "loading", "placeholder"]))
}
}

})